import React, { Component } from "react";
import Rendersidebar from "../../Components/Sidebar/sidebar";
import { SIDE_NAV_ITEMS } from "../../api-constant";
import NewNavBar from "../../Components/NavBar/Navbar";
import ResponsiveSidebar from "../../Components/Sidebar/Responsive/SideBar";
import { Dashboardempty } from "./dashboard-empty";
import axios from "axios";
import addAccessTokenToUrl from "../../Utils/Axios/addTokenToUrl";
import { withRouter } from "react-router";

class Emptydashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      enableNotification: false,
      successMessage: "",
      filteredSentRespondants: null,
      orgId: "",
      sellerId: "",
      intrument_id: "",
      id: "",
      participant_id: "",
      multi_rater: null,
      assessmentCompletedCount: "",
      assessmentType: "",
    };
  }

  componentDidMount() {
    localStorage.setItem("new_user", false);
    const assessmentType = this.props.match.params.assessmentType;
    /* handle api calls */
    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        if (assessmentType == "assessment") {
          const filteredSentRespondants = response.data.user_assessments[0];
          this.setState({
            intrument_id: filteredSentRespondants.instrument__id,
            id: filteredSentRespondants.id,
            orgId: filteredSentRespondants.organisation,
            sellerId: filteredSentRespondants.seller,
            participant_id: filteredSentRespondants.participant__id,
            multi_rater: filteredSentRespondants.instrument__is_multi_rater,
            assessmentCompletedCount:
              filteredSentRespondants.assessment_completed_count,
            assessmentType,
          });
        } else null;

        this.setState({});
      })
      .catch((error) => {
        console.error(error);
      });
  }

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  render() {
    return (
      <React.Fragment>
        <NewNavBar
          enableNotification={this.state.enableNotification}
          handleNotification={this.handleNotification}
          successMessage={this.state.successMessage}
          respondentEmail={this.state.respondentEmail}
          updateMessage={this.state.updateMessage}
        />
        <Rendersidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
        />
        <ResponsiveSidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
          sidebarOpen={this.state.sidebarOpen}
          onSetSidebarOpen={this.onSetSidebarOpen}
        />
        <Dashboardempty
          orgId={this.state.orgId}
          sellerId={this.state.sellerId}
          intrument_id={this.state.intrument_id}
          id={this.state.id}
          participant_id={this.state.participant_id}
          multi_rater={this.state.multi_rater}
          assessmentCompletedCount={this.state.assessmentCompletedCount}
          assessmentType={this.state.assessmentType}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(Emptydashboard);



// WEBPACK FOOTER //
// ./src/new/Dashboard/Dashboard-empty/index.jsx